import {
  isCurrent,
  isDowngrading,
  isIntervalDowngrade,
  isIntervalUpgrade,
  isRenewing,
  isResuming,
  isUpgrading,
} from "@/react/helpers/plansHelpers";
import type { Plan } from "@circle-react/types";

export const getButtonTranslationKey = (plan: Plan) => {
  const { plan_action } = plan;

  if (isUpgrading(plan_action) || isDowngrading(plan_action)) {
    return `pricing_plans.variant_c_actions.${plan_action}`;
  }
  if (isIntervalUpgrade(plan)) {
    return `pricing_plans.variant_c_actions.switch_to_annual`;
  }
  if (isIntervalDowngrade(plan)) {
    return `pricing_plans.variant_c_actions.switch_to_monthly`;
  }
  return `pricing_plans.actions.${plan_action}`;
};

export type ButtonVariant =
  | "primary"
  | "circle"
  | "secondary"
  | "marketing-gradient";

export const getButtonVariant = (plan: Plan): ButtonVariant | undefined => {
  const { plan_action } = plan;

  if (isUpgrading(plan_action)) {
    return "marketing-gradient";
  }

  if (isIntervalUpgrade(plan)) {
    return "marketing-gradient";
  }

  if (isIntervalDowngrade(plan)) {
    return "secondary";
  }

  if (
    isResuming(plan_action) ||
    isRenewing(plan_action) ||
    isCurrent(plan_action)
  ) {
    return "circle";
  }

  if (isDowngrading(plan_action)) {
    return "secondary";
  }

  return undefined;
};
